import { useNavigate } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function Error404() {
  const navigate = useNavigate();

  return (
    <>
      <DashboardNavbar />
      <MDBox
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        textAlign="center"
        px={2}
      >
        <MDTypography variant="h1" fontWeight="bold" color="dark">
          404
        </MDTypography>
        <MDTypography variant="h5" fontWeight="regular" mb={1}>
          Page not found
        </MDTypography>
        <MDTypography variant="body2" color="text" mb={4}>
          The page you&apos;re looking for doesn&apos;t exist or you don&apos;t have
          access to it.
        </MDTypography>
        <MDButton variant="gradient" color="info" onClick={() => navigate("/Live-Map")}>
          Go back home
        </MDButton>
      </MDBox>
    </>
  );
}

export default Error404;
